import { render, staticRenderFns } from "./MediaDatabase.vue?vue&type=template&id=9c95c9cc&scoped=true&"
import script from "./MediaDatabase.vue?vue&type=script&lang=js&"
export * from "./MediaDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c95c9cc",
  null
  
)

export default component.exports